import React from 'react';

interface BlockedUser {
    id: number;
    name: string;
    blockedDate: string;
}

interface BlockedUserItemProps {
    user: BlockedUser;
    onUnblock: (user: BlockedUser) => void;
}

export const BlockedUserItem: React.FC<BlockedUserItemProps> = ({ user, onUnblock }) => {
    return (
        <div className="user-item">
            <div className="user-avatar">👤</div>
            <div className="user-info">
                <div className="user-name">{user.name}</div>
                <div className="blocked-date">{user.blockedDate} 차단</div>
            </div>
            <button
                className="unblock-button"
                onClick={() => onUnblock(user)}
            >
                차단 해제
            </button>
        </div>
    );
};
